// ** Initial State
const initialState = {
  checkList: [],
  checkItemList: [],
  categoryList: [],
  clientCompanyList: [],
  selectedCheckItem: {},
  total: 1,
  params: {}
}

const checklist = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CHECKLIST':
      return { ...state, 
                  checkList: action.data.checkList,
                  categoryList: action.data.categoryList,
                  clientCompanyList: action.data.clientCompanyList
              }
    case 'GET_CHECKITEMLIST':
      return { ...state, 
                  checkItemList: action.data.checkItemList
              }
    case 'INSERT_CHECKLIST':
      return {
        ...state,
        data: action.data
        // total: action.totalPages,
        // params: action.params
      }
    case 'SELECT_ITEM_DATA':
      return {
        ...state,
        selectedCheckItem: action.data
      }
    default:
      return { ...state }
  }
}
export default checklist
